import i18n from 'i18next';
import * as LanguageDetector from 'i18next-browser-languagedetector';
import { reactI18nextModule } from 'react-i18next';

import { enUS as enUSLang } from './locales/enUS/enUS.json';
import { fr as frCALang } from './locales/fr/fr.json';

// the translations
const resources = {
  'en-US': {
    translation: enUSLang
  },
  'fr-CA': {
    translation: frCALang
  }
};

i18n
  // detect user language learn more:
  // https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to the react-i18next components. Alternative use the
  // I18nextProvider: https://react.i18next.com/components/i18nextprovider
  .use(reactI18nextModule)
  // init i18next for all options read:
  // https://www.i18next.com/overview/configuration-options
  .init(
    {
      fallbackLng: 'en-US',
      debug: false,
      resources,
      interpolation: {
        escapeValue: false // not needed for react as it escapes by default
      },

      // special options for react-i18next learn more:
      // https://react.i18next.com/components/i18next-instance
      react: {
        wait: true
      }
    },
    (e: any) => {
      if (e != null) {
        console.error(e);
      }
    }
  );

export default i18n;
